module.exports = __webpack_public_path__ + "static/media/slider.ff4f0219.less";